/**
 * Class description
 *
 * Created: 2019-07-30
 * @author jonas
 */
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";

export class ImmortalFruitsTextStyles {

    public static FS_OUTRO_COUNT_UP = {
        fontName: "CountUpWheel",
        fontSize: 18,
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    public static WHEEL_COUNTUP = {
        fontName: "CountUpWheel",
        fontSize: 18,
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    public static BETLINE_FONT: BitmapTextStyleOptions = {
        font: {
            name: "betLineFont",
            size: 18
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    public static WHEEL_NUM: BitmapTextStyleOptions = {
        font: {
            name: "CountUpOutro",
            size: 55
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static WIN_COUNT_UP: BitmapTextStyleOptions = {
        font: {
            name: "NumbersWinCountUp",
            size: 40
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static BIG_WIN_COUNT_UP: BitmapTextStyleOptions = {
        font: {
            name: "NumbersWinCountUp",
            size: 40
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static FREESPIN_COUNTER: PIXI.TextStyle = new PIXI.TextStyle({
        fill: "#ffffff",
        fontFamily: "Open Sans",
        fontSize: 50,
        fontStyle: FontStyle.NORMAL,
        fontWeight: FontWeight.BOLD
    });

    public static DEFAULT_SCREEN_TEXT: PIXI.TextStyle = new PIXI.TextStyle({
        fill: "#ffffff",
        fontFamily: "Open Sans",
        fontSize: 90,
        fontStyle: FontStyle.NORMAL,
        fontWeight: FontWeight.BOLD
    });

    public static FREESPINS_NUMBERS_TEXT: PIXI.TextStyle = new PIXI.TextStyle({
        fill: "#ffffff",
        fontFamily: "Open Sans",
        fontSize: 180,
        fontStyle: FontStyle.NORMAL,
        fontWeight: FontWeight.BOLD
    });

    static BIG_WIN_TEXT: PIXI.TextStyle = new PIXI.TextStyle({
        dropShadow: true,
        dropShadowAlpha: 1.0,
        dropShadowAngle: 1.5,
        dropShadowBlur: 5,
        dropShadowDistance: 20,

        fill: [
            "#FFFF00",
            "#ffffff",
            "#ff8040",
            "#ffbe7d",
            "#572c00"
        ],
        fillGradientStops: [
            0.1,
            0.3,
            0.4,
            0.5,
            0.7
        ],
        miterLimit: 2,
        stroke: "#ffa940",
        strokeThickness: 7,

        fontFamily: "Open Sans",
        fontSize: 180,
        fontStyle: FontStyle.NORMAL,
        fontWeight: FontWeight.BOLD,
        align: "center"
    });
}